module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "heading"
  }, [_vm._v("4.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("T"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hey’ll have found you first thing in the morning. I even know who’ll have been the first to spot you, that idiot who reeks of wine and eternal clothing.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("He’ll have turned on every spotlight on the field just for the fun of defacing the dawn. Good work, that means he wallowed in the flood of light in the middle of the spectacle. It’s not something you see every day, scoring a goal with a dead body.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Much less yours.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A famous dead body.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The hammock netting will cradle the perpetual slumber of your renowned body. How poetic.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Makes you want to lick your whiskers.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I prepared you beautifully for the show, as per orders received: I set you up in a fetal position, you always used to say that living is already dying a little bit, what a mediocre thought. And after all, you were always such a little baby boy! So I equipped your banality and even delivered you a tidbit, a mouthful of meadow in your mouth. Suckle nicely on your grass nipple. Console yourself for eternity.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The drunkard and his stench will have approached the goalposts closest to the cemetery, I picked them special.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Whoever looks at you has already been infected.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The idiot will certainly be incapable of appreciating the refinement of the thing.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("You see all the gifts I give you? Come, give us a peck on the cheek, don’t be shy! Hug me, call me your little man, kid brother, sister, old friend. You’re so fond of rummaging through family names for strangers you never see, that you forget about even as you’re watching them.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Say it to me: genius, angel, friend, dear heart, mother love. Recite once again the rosary of slimy flattery.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Whore. Worm. Scabby wound, sewer of my hatred.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Slap your tongue against your palate to give birth to sounds, songs, grunts of advanced passion. Of friendship that you don’t even know. Of eternity that is beneath your consideration. Of filthy, disgusting beauty.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The lives and lives that you tear asunder.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("You turned me into a man who’d been castrated with all his senses wide awake. You turned me into a woman who’d given birth to her own demise. A beast, drawn and quartered. Vertebrae dangling from the meat hook of your ill will. ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("It’s dull, you know, not to have a face.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("It’s difficult to insist with this stump, to go on being alive.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("You no longer have this problem. Maybe right now you’re the riveting star of the autopsy session, perhaps the conscientious doctor is plunging in the scalpel as I speak, and it’s just too bad that you can’t feel the sweetness of the slice. ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Good night, brother.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b327e74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/threeimperfect_00006.vue
// module id = 84
// module chunks = 0